module.exports = __webpack_public_path__ + "img/cslogo.75580d2f.png";